import React from 'react';

import './index.scss';

const Description = ({ size = 'medium', content = '', color = '' }) => (
  <p className={size + ' ' + color}>
    {content}
  </p>
);

export default Description;
